import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4">
              FAQ
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
              Frequently Asked
              <br />
              Questions About LitBuy
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
              >
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-bold">
                    {(index + 1).toString().padStart(2, '0')}
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">
                      {item.question}
                    </h3>
                    <span className="inline-block mt-1 text-xs text-foreground-400">
                      #{item.question.toLowerCase().includes('safety') ? 'Safety' : item.question.toLowerCase().includes('compare') ? 'Comparison' : item.question.toLowerCase().includes('template') ? 'Templates' : 'General'}
                    </span>
                  </div>
                </div>
                <p className="mt-4 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  &ldquo;{item.answer}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}